export default {
  waived: {
    id: 'bo_seller.profile.legal_details.dsa_block.waived_block_content.waived',
    defaultMessage: 'Waived',
  },
  title: {
    id: 'bo_seller.profile.legal_details.dsa_block.waived_block_content.title',
    defaultMessage: 'Default contact for products',
  },
  subtitle: {
    id: 'bo_seller.profile.legal_details.dsa_block.waived_block_content.subtitle',
    defaultMessage:
      "By confirming that all your products are manufactured within the EU or Northern Ireland, you don't need to add a default contact for your products. If this ever changes, select 'Edit' to add a default contact for your products manufactured outside of the EU or Northern Ireland.",
  },
  edit: {
    id: 'bo_seller.profile.legal_details.dsa_block.waived_block_content.edit',
    defaultMessage: 'Edit',
  },
}
